import flash from '@shared/flash';

export const defaultErrorHandler = error => {
  flash({ error: 'Произошла неизвестная ошибка' });
  throw error;
};